import { render, staticRenderFns } from "./Headset.vue?vue&type=template&id=2737374d&scoped=true&"
import script from "./Headset.vue?vue&type=script&lang=js&"
export * from "./Headset.vue?vue&type=script&lang=js&"
import style0 from "./Headset.vue?vue&type=style&index=0&id=2737374d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2737374d",
  null
  
)

export default component.exports